import { useEffect, useState } from 'react'
import axios from "axios";
import { useNotification } from '../../../hooks/useNotification';
import { useForm } from "../../../hooks/useForm";
import { useErrorInputs } from "../../../hooks/useErrorInputs";
import { useAudit } from "../../../hooks/useAudit";
import { useNavigate } from 'react-router-dom';

const baseUrl = process.env.REACT_APP_URL_PATH;
const baseUrlFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;

export function useManageEpayco(subscriptionPlan) {
    const navigate = useNavigate();
    const { getAuditData } = useAudit();
    const [sendNotification] = useNotification();

    const [id_unique, setId_unique] = useState(null);
    const [sdkReady, setSdkReady] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form, handleInputChange] = useForm({
        full_username: "",
        email: "",
        phone: "",
        tax_id: "",
        id_number: "",
        company_name: "",
        address: "",
        otpVefication: "",
        terms_conditions: false,
        habeasData: false,
    });
    const requiredFields = ['full_username', 'phone', 'email', 'tax_id', 'id_number', 'company_name', 'address', 'terms_conditions', 'habeasData'];
    const [errorInputs, , , validForm] = useErrorInputs({});

    useEffect(() => {
        if (window.ePayco) {
            setSdkReady(true);
            return;
        }

        const script = document.createElement("script");
        script.src = "https://checkout.epayco.co/checkout.js";
        script.async = true;

        script.onload = () => setSdkReady(true);
        document.body.appendChild(script);

        return () => {
            // optional cleanup
            // document.body.removeChild(script);
        };
    }, []);

    const SendEmailOtp = async () => {
        const auditData = await getAuditData();
        try {
            let config = {
                method: 'POST',
                url: baseUrlFlow,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic 23456789iyugjhkyu897yuhgbu`
                },
                data: JSON.stringify({
                    id_flow: "900114098-SEND-OTP-EPAYCO",
                    plan_uuid: subscriptionPlan,
                    email: form.email,
                    full_username: form.full_username,
                    phone: form.phone,
                    tax_id: form.tax_id,
                    id_number: form.id_number,
                    company_name: form.company_name,
                    address: form.address,
                    terms_conditions: form.terms_conditions,
                    habeasData: form.habeasData,
                    auditData
                })
            };
            const response = await axios.request(config);
            if (response.status === 200) {
                setId_unique(response.data);
                sendNotification({ msg: "Revise en su bandeja de entrada el codigo de confirmación", variant: 'success' });
                setOtpSent(true);
            } else {
                sendNotification({ msg: "Error al enviar el código de confirmación", variant: 'error' });
            }
        } catch (error) {
            console.log('error', error);
        }
        setTimeout(() => setLoading(false), 2000);
    };

    const OpenEapyco = (info_plan) => {
        const handler = window.ePayco.checkout.configure({
            key: "4c06eb02ecaad89594af99cab23e3a2e",
            test: true,
        });

        const data = {
            name: "Registro y acceso al sistema AIAutomation",
            description: `Plan AIAutomation ${info_plan.plan_name} - ${info_plan.plan_name}`,
            invoice: "AIA-" + Date.now(),
            currency: "COP",
            amount: info_plan.plan_price,
            tax_base: "0",
            tax: "0",
            country: "CO",
            lang: "es",
            external: "true",
            // Extra info
            extra1: info_plan.id_unique,
            extra2: subscriptionPlan,
            response: `${baseUrl}/payment-response`,
            confirmation: baseUrlFlow,
            url_confirmation: baseUrlFlow,
            "data-epayco-confirmation": baseUrlFlow,
            p_confirm_method: "POST",
            name_billing: form.full_username,
            address_billing: form.address,
            type_doc_billing: form.tax_id,
            mobilephone_billing: form.phone,
            number_doc_billing: form.id_number,
        };
        handler.open(data);
        setTimeout(() => setLoading(false), 1000);
    }

    const saveComapny = async (info_plan) => {
        try {
            let config = {
                method: 'POST',
                url: baseUrlFlow,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic 23456789iyugjhkyu897yuhgbu`
                },
                data: JSON.stringify({
                    id_flow: "900114098-API-VALIDATE_SIGNATURE_EPAYCO",
                    plan_uuid: subscriptionPlan,
                    id_unique: info_plan.id_unique,
                    free: "true"
                })
            };
            const response = await axios.request(config);
            console.log('response', response);
            if (response.status === 200) {
                sendNotification({ msg: "Revise en su bandeja de entrada; allí encontrará la información para el ingreso a la plataforma", variant: 'success' });
                setTimeout(() => handleCancel(), 1500);
            } else {
                sendNotification({ msg: "Error al guardar la información", variant: 'error' });
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const validateCode = async () => {
        if (!validForm(['otpVefication'], form)) {
            sendNotification({
                msg: "Por favor complete todos los campos requeridos",
                variant: "error",
            });
            return;
        }
        setLoading(true);
        try {
            let config = {
                method: 'POST',
                url: baseUrlFlow,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic 23456789iyugjhkyu897yuhgbu`
                },
                data: JSON.stringify({
                    id_flow: "900114098-VALIDATE-OTP-EPAYCO",
                    otp: form.otpVefication,
                    id_unique
                })
            };
            const response = await axios.request(config);
            if (response.status === 200 && response.data.status === 'VALIDO') {
                if (Number(response.data.plan_price) === 0) {
                    saveComapny(response.data);
                }
                else
                    OpenEapyco(response.data);
            }
            else {
                sendNotification({ msg: "Código de verificación incorrecto", variant: 'error' });
            }
        } catch (error) {
            console.log('error', error);
        }
        setLoading(false);
    }

    const handleSubmit = () => {
        if (!validForm(requiredFields, form) || !form.terms_conditions || !form.habeasData) {
            sendNotification({
                msg: "Por favor complete todos los campos requeridos",
                variant: "error",
            });
            return;
        }
        setLoading(true);
        SendEmailOtp();
    };

    const handleCancel = () => navigate('/login');

    return {
        form,
        sdkReady,
        errorInputs,
        otpSent,
        loading,
        handleInputChange,
        handleSubmit,
        validateCode,
        handleCancel
    }
}
